import { IssueEntity } from '../types/IssueEntity'
import { ConvertibleInvestorCommitment } from '@finance-lab/utils/types'

export const getInvestorAmountInCash = (investor: ConvertibleInvestorCommitment, totalUnitSize: number | null) => {
    if (investor.amountInCash !== null) return Number(investor.amountInCash)
    if (totalUnitSize === null || investor.amountInPercentage === null) return null

    return (Number(investor.amountInPercentage) / 100) * totalUnitSize
}

export const getInvestorAmountInPercentage = (
    investor: ConvertibleInvestorCommitment,
    totalUnitSize: number | null,
) => {
    if (investor.amountInPercentage !== null) return Number(investor.amountInPercentage)
    if (totalUnitSize === null || investor.amountInCash === null) return null

    return (Number(investor.amountInCash) / totalUnitSize) * 100
}

export const getIssueTotalUnitSize = ({
    type,
    abbTarget,
    offeredUnits,
    offeredUnitsUnlisted,
    unitSubTotal,
    unitSubPrice,
    secondaryOffering,
    ipoIntervalHigh,
    ipoIntervalLow,
}: Pick<
    IssueEntity,
    | 'type'
    | 'offeredUnits'
    | 'offeredUnitsUnlisted'
    | 'unitSubTotal'
    | 'unitSubPrice'
    | 'secondaryOffering'
    | 'abbTarget'
    | 'ipoIntervalLow'
    | 'ipoIntervalHigh'
>) => {
    if (type === 'IPO') {
        const totalOfferedUnits = (offeredUnits || 0) + (secondaryOffering || 0)
        if (offeredUnits === null && secondaryOffering === null) return null

        if (unitSubPrice === null && ipoIntervalLow !== null && ipoIntervalHigh !== null) {
            return ((+ipoIntervalHigh + +ipoIntervalLow) / 2) * totalOfferedUnits
        }

        if (unitSubPrice === null) {
            return null
        }

        return totalOfferedUnits * +unitSubPrice
    }

    const totalOfferedUnits = offeredUnitsUnlisted !== null ? (offeredUnits || 0) + offeredUnitsUnlisted : offeredUnits
    const unitsCount = type === 'Rights issue' ? totalOfferedUnits : (unitSubTotal ?? totalOfferedUnits)

    if (unitsCount === null || unitSubPrice === null) {
        return abbTarget
    }

    return unitsCount * +unitSubPrice
}
